import { ProductPromotionsFeatureRoutesConfig } from './ProductPromotionsFeatureRoutesConfig';

export interface ProductPromotionsFeatureConfig {
  routes?: ProductPromotionsFeatureRoutesConfig;
}

export const defaultProductPromotionsFeatureConfig: ProductPromotionsFeatureConfig = {};
